import { Link } from "react-router-dom";
import { FaAddressBook, FaRegistered, FaBox } from 'react-icons/fa6'
import { Card } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";


export default function MenuDatos() {
    return <>
        <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>Datos</Breadcrumb.Item>
        </Breadcrumb>
        <nav>
            <Row>
                <Col sm="4" className="mb-2">
                    <Link to="/marcas">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaRegistered></FaRegistered>
                                </Card.Title>
                                <Card.Text>Marcas</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="4" className="mb-2">
                    <Link to="/productos">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaBox></FaBox>
                                </Card.Title>
                                <Card.Text>Productos</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col sm="4" className="mb-2">
                    <Link to="/clientes">
                        <Card bg="secondary">
                            <Card.Body>
                                <Card.Title>
                                    <FaAddressBook></FaAddressBook>
                                </Card.Title>
                                <Card.Text>Clientes</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </nav>
    </>
}